"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getJudgeBound = getJudgeBound;
exports.isValidCalendarDate = isValidCalendarDate;
function getJudgeBound(key, value) {
    var judgeUpperBound = new Date(value);
    switch (key) {
        case "day":
            judgeUpperBound.setHours(0, 0, 0, 0);break;
        case "hour":
            judgeUpperBound.setMinutes(0, 0, 0);break;
        case "minute":
            judgeUpperBound.setSeconds(0, 0);break;
        case "second":
            judgeUpperBound.setMilliseconds(0);break;
    }
    judgeUpperBound.setMilliseconds(judgeUpperBound.getMilliseconds() - 1);

    var judgeLowerBound = new Date(judgeUpperBound);
    switch (key) {
        case "day":
            judgeLowerBound.setDate(judgeLowerBound.getDate() + 1);break;
        case "hour":
            judgeLowerBound.setHours(judgeLowerBound.getHours() + 1);break;
        case "minute":
            judgeLowerBound.setMinutes(judgeLowerBound.getMinutes() + 1);break;
        case "second":
            judgeLowerBound.setSeconds(judgeLowerBound.getSeconds() + 1);break;
    }
    judgeLowerBound.setMilliseconds(judgeLowerBound.getMilliseconds());

    return { upper: judgeUpperBound, lower: judgeLowerBound };
}

function isValidCalendarDate(calendarDate, disabledDateFn, props) {
    if (isFunction(disabledDateFn) && disabledDateFn(calendarDate)) {
        return false;
    }

    var _getJudgeBound = getJudgeBound("day", calendarDate),
        judgeUpperBound = _getJudgeBound.upper,
        judgeLowerBound = _getJudgeBound.lower;

    if (props) {
        if (props.altUpperBound && props.altUpperBound < judgeUpperBound) {
            return false;
        }
        if (props.altLowerBound && props.altLowerBound > judgeLowerBound) {
            return false;
        }
    }

    return true;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-calendar-ex@0.0.4@@alicd/crui-calendar-ex/lib/boundUtil.js
// module id = 267
// module chunks = 0